import { sortBy } from 'lib/array/arrayUtils'

export default function parseGoogleVisionGiftCardScan(googleVisionResult: any) {
  const textAnnotations = googleVisionResult?.responses?.[0]?.textAnnotations
  if (!Array.isArray(textAnnotations)) {
    return {
      status: 'error' as const,
      error: new Error('No card number found'),
    }
  }

  const strings: Array<string> = textAnnotations.map((annotation) => annotation.description)

  // Online gift cards always have a 16 digit card number
  // Physical cards can have 18 or 19 digits
  const cardNumberCandidates = strings
    .filter((str) => (str.length === 16 && str.match(/^[A-Z\d]+$/)) || (str.length === 18 || str.length === 19) && str.match(/^\d+$/))

  if (cardNumberCandidates.length === 0) {
    return {
      status: 'error' as const,
      error: new Error('No card number found'),
    }
  }

  // Assumption: The longest number is the bar code number
  const barCodeNumber = sortBy(cardNumberCandidates.filter(str => str.match(/^\d+$/)), (str) => str.length, 'desc')[0]

  const sortedCardNumberCandidates = sortBy(cardNumberCandidates, (str) => {
    // Assign a value to the likelihood of this being the right card number
    if (str.length === 16) {
      // Online card shouldn't have a 0 or O
      return str.match(/[O0]/) ? 1 : 2
    }
    if (str.length >= 18) {
      // Bar code ends with the card number
      if (barCodeNumber && barCodeNumber.endsWith(str)) { return 3 }
      // They always seem to start with 603
      if (str.startsWith('603')) { return 2 }
      return 1
    }
    return 0
  }, 'desc')

  const cardNumber = sortedCardNumberCandidates[0]

  let accessCode: string | undefined
  if (cardNumber.length >= 18) {
    // Access code is always 10 characters long
    const accessCodeCandidates = strings.filter((str) => str.length === 10 && str.match(/^[A-Z\d]+$/))
    accessCode = accessCodeCandidates[0]
  }

  return {
    status: 'success' as const,
    cardNumber,
    accessCode,
  }
}
